const nextbtn = document.querySelector('.swiper-button-next');
const prevbtn = document.querySelector('.swiper-button-prev');
let slides = document.querySelectorAll('.swiper-slide');
function checkSlides() {
    if (slides.length <= 4) {
        if (document.querySelector('.swiper-button-next')) {
            nextbtn.style.display = 'none';
        }
        if (document.querySelector('.swiper-button-prev')) {
            prevbtn.style.display = 'none';
        }
    } else {
        if (document.querySelector('.swiper-button-next')) {
            nextbtn.style.display = '';
        }
        if (document.querySelector('.swiper-button-prev')) {
            prevbtn.style.display = '';
        }

    }
}
checkSlides();